export function addCurrent(patrimonygroup) {
    return {
        type: 'ADD_CURRENT',
        patrimonygroup,
    }
}
